import EyeIcon from './components/icons/EyeIcon.vue';
import MarkGithubIcon from './components/icons/MarkGithubIcon.vue';
import RepoForkedIcon from './components/icons/RepoForkedIcon.vue';
import StarIcon from './components/icons/StarIcon.vue';
import SyncIcon from './components/icons/SyncIcon.vue';

/**
 * Get all SVG icons as component.
 *
 * @export
 */
export default () => {
	return {
		EyeIcon,
		MarkGithubIcon,
		RepoForkedIcon,
		StarIcon,
		SyncIcon
	};
};
